import { FC, useMemo } from "react";
import { Paper, Skeleton, Typography } from "@mui/material";
import useBasePath from "src/utils/hooks/useBasePath";
import __ from "src/utils/Translations";
import { useCompanyId } from "src/Pages/Company/CompanyContext";
import { LogLevel, useLogStatus } from "src/utils/newRelic/useLogStatus";
import { useFetchFeatureConfiguration } from "src/Pages/Company/Absences/api/featureConfiguration.queries";
import { transformFeatureConfigToFormValues } from "src/utils/Company/Absences/parseFeatureConfiguration";
import BreadcrumbsMui from "src/Components/BreadcrumbsMui/BreadcrumbsMui";
import ErrorDataFetching from "src/Components/Error/ErrorDataFetching";
import Title from "src/Pages/Company/Absences/Title/Title";
import AbsencesVisibilityForm from "./AbsencesVisibilityForm";

export interface IFormValues {
  [key: string]: boolean;
}

const AbsencesVisibility: FC = () => {
  const basePath = useBasePath();
  const companyId = useCompanyId();
  const logStatus = useLogStatus();

  if (!companyId) {
    logStatus({
      level: LogLevel.DEBUG,
      message: "No company ID provided.",
      file: "AbsencesVisibility.tsx",
    });
  }

  const {
    data: featureConfigurationData,
    isFetching,
    isError,
  } = useFetchFeatureConfiguration(companyId);

  const defaultValues = useMemo(
    () => transformFeatureConfigToFormValues(featureConfigurationData),
    [featureConfigurationData]
  );

  return (
    <>
      <BreadcrumbsMui
        items={[
          {
            label: __("Nieobecności"),
            to: `${basePath}/absences`,
          },
          {
            label: __("Włączanie widoczności modułu"),
          },
        ]}
      />
      <Title title={__("Włączanie widoczności modułu")} />
      <Paper sx={{ p: "2rem" }} data-testid="absences-visibility">
        <Typography variant="h6" component="h2" sx={{ mb: "1rem" }}>
          {__("Widoczność Modułu Nieobecności dla pracowników")}
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ margin: "normal" }}
        >
          {__(
            "Wyłączenie widoczności modułu spowoduje ukrycie go dla pracowników."
          )}
        </Typography>
        {/* eslint-disable-next-line no-nested-ternary */}
        {isError ? (
          <ErrorDataFetching />
        ) : isFetching ? (
          <Skeleton height="2rem" width="50%" sx={{ m: "1rem 0" }} />
        ) : (
          <AbsencesVisibilityForm defaultValues={defaultValues} />
        )}
      </Paper>
    </>
  );
};

export default AbsencesVisibility;
